import Vue from 'vue'
import store from '../store/index'
import * as _ from 'lodash'
import StateHelper from './state-abbreviation'
import { getBoundaries } from './state-selector'

export default {
	_isGoogleLoaded: function (opts){
    if(!this.static_promise){
      this.static_promise = new Promise( (resolve,reject)=> {
        window['__onGoogleLoaded'] = (ev) => {
          if(opts && opts.infobox){
            this.loadInfobox(function(){
              
              google.maps.Polygon.prototype.my_getBounds=function(){
                let bounds = new google.maps.LatLngBounds()
                this.getPath().forEach(function(element,index){bounds.extend(element)})
                return bounds
              }

              resolve(window.gapi);
            });
            resolve(window.gapi);
          }
        }
        this.loadGoogle()
      })
    }
    return this.static_promise
  },
  loadGoogle: function () {
    var node = document.createElement('script');
    node.src = "https://maps.googleapis.com/maps/api/js?libraries=geometry&callback=__onGoogleLoaded&key=AIzaSyA-bauLzG4wFcSfhaqtDjaqw5wNSgxLp7g&region=US";
    node.type = 'text/javascript';
    document.getElementsByTagName('body')[0].appendChild(node);
  },
  loadInfobox : function (_callback) {
    let node = document.createElement('script');
    node.onload = _callback;
    node.src = '//cdn.irelo.com/shared/js/google/maps/infobox_packed.js';
    node.type = 'text/javascript';
    document.getElementsByTagName('body')[0].appendChild(node);
  },
  refreshMap: function() {
    return new Promise((resolve,reject) => {
      let map = new google.maps.Map(document.getElementById('map'), {
        center: {lat: 37.964253, lng: -91.831833},
        zoom: 5,
        scrollwheel: false
      })
      store.commit("setmap", map);
      resolve(true)
    })
  },
  capitalize(name) {
    return name.charAt(0).toUpperCase() + name.slice(1);
  },
  createCircle(options, center) {
    let circle =  new google.maps.Circle({
      strokeColor: options['strokeColor'] ? options['strokeColor'] : '#DF5435' ,
      strokeOpacity: options['strokeOpacity'] ? options['strokeOpacity'] : 1,
      strokeWeight:  options['strokeWeight'] ? options['strokeWeight'] :  1,
      fillColor:  options['fillColor'] ? options['fillColor'] : '#DF5435',
      fillOpacity:  options['fillOpacity'] ? options['fillOpacity'] : 0.2,
      map: store.getters.map,
      radius:  options['radius'] ? options['radius'] : 43000,
      center: center,
      zIndex:  options['zIndex'] ? options['zIndex'] : 10,
    });
    return circle; 
  },
  initSelectedStateCircles(state){
    let center =  {lat: state.polygon.my_getBounds().getCenter().lat(), lng: state.polygon.my_getBounds().getCenter().lng() }

    if(state.outer_circle){
      state.outer_circle.setMap(null)
      state.outer_circle = null;
    }  
    if(!state.outer_circle){
      state.outer_circle = this.createCircle([], center)
    }

    if(state.inner_circle){
      state.inner_circle.setMap(null)
      state.inner_circle = null;
    }  
    if(!state.inner_circle){
      let options= {
        fillOpacity: 0.5,
        radius: 34000,
        zIndex: 11,
      }
      state.inner_circle = this.createCircle(options, center)
    }

    if(state.inner_inner_circle){
      state.inner_inner_circle.setMap(null)
      state.inner_inner_circle = null;
    }
    if(!state.inner_inner_circle){
      let options= {
        fillOpacity: 0.8,
        radius: 22000,
        zIndex: 12,
      }
      state.inner_inner_circle = this.createCircle(options, center)
    }
  },
  initSelectedStates(){
    let states = _.uniqBy(store.getters.selectedAreas, 'state')
    let context = this
    let boundaries = getBoundaries()
    _.forEach(store.getters.selectedAreas, function(state) {
      if(state.status == "Not Active" ){
        context.exclusion = true;
        return;
      }

      let state_name = context.capitalize(state.state);
      
      if(state.polygon){
        state.polygon.setMap(null)
        state.polygon = null
      }
      state.polygon = new google.maps.Polygon({
        paths: boundaries[state_name],
        strokeColor: '#DF5435',
        strokeOpacity: 0.7,
        strokeWeight: 3,
        fillColor: '#DF5435',
        fillOpacity: 0.3,
        map: store.getters.map,
        zIndex:10
      })

      context.initSelectedStateCircles(state);
        
    })
  },
  makeStatePolygon(stateData,boundaries, options){
    store.getters.polygons[stateData] = {}
    store.getters.polygons[stateData] = new google.maps.Polygon({
      paths: boundaries[stateData],
      strokeColor: options['strokeColor'] ? options['strokeColor'] : '#8A8E93',
      strokeOpacity: 0,
      strokeWeight:  options['strokeWeight'] ? options['strokeWeight'] : 3,
      fillColor: options['fillColor'] ? options['fillColor'] : '#8A8E93',
      fillOpacity: 0,
      zIndex: 999
    })
  },

}


// WEBPACK FOOTER //
// ./src/helpers/map-helper.js